import React from "react";
import Dropdown, { DropdownOption } from "./Dropdown";
import { MONTHS_OPTIONS } from "./consts";

export interface MonthDropdownProps {
  monthIndex: number | null;
  onChange: (value: DropdownOption | null) => void;
  placeholder?: string;
  className?: string;
}

const MonthDropdown: React.FC<MonthDropdownProps> = ({
  monthIndex,
  onChange,
  placeholder = "Select Month",
  className,
}) => {
  const monthOption = MONTHS_OPTIONS.filter((m) => m.code === monthIndex)[0];

  return (
    <Dropdown
      options={MONTHS_OPTIONS as DropdownOption[]}
      value={monthOption}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
    />
  );
};

export default MonthDropdown;
